import { add, sub, formatRFC3339 } from 'date-fns'

import type { AxiosResponse } from 'axios'
import axios from 'axios'

import type { Device } from '@/pages/Device/Device'
import {
  ZKL_3000_RC,
  ZKL_3000_RC_AFTC,
  ZKL_3000_RCC,
} from '@/pages/Device/SupportedTypes'
import { samApiClient } from '@/api'

// Lifespan a battery board is allowed to be used for
const BATTERY_BOARD_LIFESPAN = {
  years: 5,
  months: 6,
}

const BATTERY_BOARD_TYPES = new Set<string>([
  ZKL_3000_RC,
  ZKL_3000_RC_AFTC,
  ZKL_3000_RCC,
])

// Determines whether this device type has a battery board
// Returns true only for ZKL variants that support it
export const deviceHasBatteryBoard = (device: Device): boolean =>
  BATTERY_BOARD_TYPES.has(device.type)

// Calculates the oldest allowed installation date
export const getMinInstallationDate = (yearsBetweenMaintenance: number): Date =>
  sub(
    add(new Date(), { years: yearsBetweenMaintenance, months: 1 }),
    BATTERY_BOARD_LIFESPAN,
  )

// endpoint is zkl-rc/{uid}/battery-board, date uses RFC3339 format
export const updateBatteryBoardDate = async (
  uid: string,
  installedAt: Date,
): Promise<AxiosResponse<void>> => {
  try {
    return await samApiClient.patch<void>(`zkl-rc/${uid}/battery-board`, {
      installedAt: formatRFC3339(installedAt), // v1 front end uses formatRFC3339
    })
  } catch (error) {
    if (!axios.isCancel(error)) throw error
    throw error
  }
}
